/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Current_LabelInputs */



/**
* | output |
* | --- |
* | "Current" |
*
* @param {Timing_Sync_Current_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_current_label = /** @type {((inputs?: Timing_Sync_Current_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Current_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Actuel")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktuell")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attuale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Текущий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actual")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("当前的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("現在")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मौजूदा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atual")
	return /** @type {LocalizedString} */ ("Current")
});